<mat-card class="slidecontent">
    <div class="headcontent">
    
        <div class="pophead">
            <h3>Link Process Intelligence</h3>
              <mat-icon  class="close" (click)="closePI(close)"  >close</mat-icon>
          </div>
        </div>
          <div class="dialog_content">
              <form  class="fix-mat-form-field" >
                <mat-form-field class="example-full-width">
                    <mat-label>Selected Task</mat-label>
                    <input matInput placeholder="Task Name" value="See how easy it is to customize Copper                    ">
                  </mat-form-field>

              <div class="sprocess" >
                <mat-form-field>
                    <mat-label>Select Process</mat-label>
                    <mat-select value="" >
                      <mat-option value="" >Patient</mat-option>
                      <mat-option value="">Real Estate</mat-option>
                      <mat-option value="">Document Filling </mat-option>
                    </mat-select>
                  </mat-form-field>  
                 <div class="create">
                    <button mat-stroked-button color="primary" [routerLink]="'/core/process'" >View Process</button>
                 </div>
              </div>
                
              <mat-form-field>
                <mat-label>Notes</mat-label>
                <textarea matInput
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="3"
                          cdkAutosizeMaxRows="5"></textarea>
              </mat-form-field>
       

              </form>
      
          </div>
    
    
    <div class="actionBtn">
    <button mat-flat-button class="cancel"  (click)="closePI(close)" >Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit"  color="primary">Link</button>
    </div>
</mat-card>

<div class="overlay"  (click)="closePI(close)"  ></div>